module.exports = __webpack_public_path__ + "static/img/545004f92039f1d32747a49d480477c9.4294ec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/545004f92039f1d32747a49d480477c9.png
// module id = c/KB
// module chunks = 73